module.exports = __webpack_public_path__ + "img/carshina22_24.0dce0ac9.jpg";